/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCustomEmailSettings200ResponseSettingsBasicAuth } from './GetCustomEmailSettings200ResponseSettingsBasicAuth';
import {
    GetCustomEmailSettings200ResponseSettingsBasicAuthFromJSON,
    GetCustomEmailSettings200ResponseSettingsBasicAuthFromJSONTyped,
    GetCustomEmailSettings200ResponseSettingsBasicAuthToJSON,
    GetCustomEmailSettings200ResponseSettingsBasicAuthToJSONTyped,
} from './GetCustomEmailSettings200ResponseSettingsBasicAuth';
import type { GetCustomEmailSettings200ResponseSettingsOauth2Auth } from './GetCustomEmailSettings200ResponseSettingsOauth2Auth';
import {
    GetCustomEmailSettings200ResponseSettingsOauth2AuthFromJSON,
    GetCustomEmailSettings200ResponseSettingsOauth2AuthFromJSONTyped,
    GetCustomEmailSettings200ResponseSettingsOauth2AuthToJSON,
    GetCustomEmailSettings200ResponseSettingsOauth2AuthToJSONTyped,
} from './GetCustomEmailSettings200ResponseSettingsOauth2Auth';

/**
 * 
 * @export
 * @interface GetCustomEmailSettings200ResponseSettings
 */
export interface GetCustomEmailSettings200ResponseSettings {
    /**
     * 
     */
    host?: string;
    /**
     * 
     */
    port?: number;
    /**
     * 
     */
    authMethod?: GetCustomEmailSettings200ResponseSettingsAuthMethodEnum;
    /**
     * 
     */
    basicAuth?: GetCustomEmailSettings200ResponseSettingsBasicAuth;
    /**
     * 
     */
    oauth2Auth?: GetCustomEmailSettings200ResponseSettingsOauth2Auth;
    /**
     * 
     */
    secure?: boolean;
    /**
     * 
     */
    fromName?: string;
    /**
     * 
     */
    fromAddress?: string;
    /**
     * 
     */
    template1Html?: string;
    /**
     * 
     */
    template2Html?: string;
    /**
     * 
     */
    subject1?: string;
    /**
     * 
     */
    subject2?: string;
}


/**
 * @export
 */
export const GetCustomEmailSettings200ResponseSettingsAuthMethodEnum = {
    Basic: 'basic',
    Oauth2: 'oauth2',
} as const;
export type GetCustomEmailSettings200ResponseSettingsAuthMethodEnum = typeof GetCustomEmailSettings200ResponseSettingsAuthMethodEnum[keyof typeof GetCustomEmailSettings200ResponseSettingsAuthMethodEnum];


/**
 * Check if a given object implements the GetCustomEmailSettings200ResponseSettings interface.
 */
export function instanceOfGetCustomEmailSettings200ResponseSettings(value: object): value is GetCustomEmailSettings200ResponseSettings {
    return true;
}

export function GetCustomEmailSettings200ResponseSettingsFromJSON(json: any): GetCustomEmailSettings200ResponseSettings {
    return GetCustomEmailSettings200ResponseSettingsFromJSONTyped(json, false);
}

export function GetCustomEmailSettings200ResponseSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCustomEmailSettings200ResponseSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'host': json['host'] == null ? undefined : json['host'],
        'port': json['port'] == null ? undefined : json['port'],
        'authMethod': json['authMethod'] == null ? undefined : json['authMethod'],
        'basicAuth': json['basicAuth'] == null ? undefined : GetCustomEmailSettings200ResponseSettingsBasicAuthFromJSON(json['basicAuth']),
        'oauth2Auth': json['oauth2Auth'] == null ? undefined : GetCustomEmailSettings200ResponseSettingsOauth2AuthFromJSON(json['oauth2Auth']),
        'secure': json['secure'] == null ? undefined : json['secure'],
        'fromName': json['fromName'] == null ? undefined : json['fromName'],
        'fromAddress': json['fromAddress'] == null ? undefined : json['fromAddress'],
        'template1Html': json['template1Html'] == null ? undefined : json['template1Html'],
        'template2Html': json['template2Html'] == null ? undefined : json['template2Html'],
        'subject1': json['subject1'] == null ? undefined : json['subject1'],
        'subject2': json['subject2'] == null ? undefined : json['subject2'],
    };
}

export function GetCustomEmailSettings200ResponseSettingsToJSON(json: any): GetCustomEmailSettings200ResponseSettings {
    return GetCustomEmailSettings200ResponseSettingsToJSONTyped(json, false);
}

export function GetCustomEmailSettings200ResponseSettingsToJSONTyped(value?: GetCustomEmailSettings200ResponseSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'host': value['host'],
        'port': value['port'],
        'authMethod': value['authMethod'],
        'basicAuth': GetCustomEmailSettings200ResponseSettingsBasicAuthToJSON(value['basicAuth']),
        'oauth2Auth': GetCustomEmailSettings200ResponseSettingsOauth2AuthToJSON(value['oauth2Auth']),
        'secure': value['secure'],
        'fromName': value['fromName'],
        'fromAddress': value['fromAddress'],
        'template1Html': value['template1Html'],
        'template2Html': value['template2Html'],
        'subject1': value['subject1'],
        'subject2': value['subject2'],
    };
}

